import { Component } from "react"
import PropTypes from "prop-types"
import LimitedTextInput from "shared/limited_text_input"
import InlineErrors from "shared/components/inline_errors"
import compact from "lodash/compact"
import uniq from "lodash/uniq"

class AppletMetadata extends Component {
  handleChange(key, value) {
    this.props.update({ [key]: value })
  }

  potentialPrimaryServices() {
    const { applet, services } = this.props

    const moduleNames = compact(
      uniq([
        applet.applet_trigger.channel_module_name,
        ...applet.applet_queries.map(aq => aq.channel_module_name),
        ...applet.applet_actions.map(aa => aa.channel_module_name),
      ])
    )

    return moduleNames.map(name => services.byModuleName[name])
  }

  renderPrimaryServiceField() {
    const { applet, errors } = this.props

    const services = this.potentialPrimaryServices()
    const primaryService = services.find(s => s.id === applet.channel_id)
    const fieldErrors = errors.getAll("/channel_id")

    return (
      <div className="field">
        <div className="label">Applet service</div>

        <InlineErrors errors={fieldErrors} />

        <div className="applet-composer-primary-service-input">
          {primaryService ? (
            <img
              className="applet-composer-primary-service-logo"
              src={primaryService.lrg_variant_image_url}
              alt={primaryService.name}
              title={primaryService.name}
              style={{ backgroundColor: `#${primaryService.brand_color}` }}
            />
          ) : (
            <div className="applet-composer-primary-service-logo" />
          )}

          <div className="input">
            <select
              disabled={!services.length}
              onChange={e => this.handleChange("channel_id", e.target.value)}
              value={applet.channel_id}
            >
              {services.length ? (
                services.map(service => (
                  <option key={service.id} value={service.id}>
                    {service.name}
                  </option>
                ))
              ) : (
                <option>Add a trigger, query, or action above</option>
              )}
            </select>

            <p className="note">
              The service logo and color that will appear on the Applet card.
            </p>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { applet, errors, showPrimaryService } = this.props

    return (
      <section>
        <div className="field">
          <div className="label">Applet title</div>
          <div className="input">
            <LimitedTextInput
              required
              value={applet.name}
              onChange={this.handleChange.bind(this, "name")}
              limit={100}
              multiline={false}
              counterPosition="top"
              hardLimit
              errors={errors.getAll("/name")}
            />
            <p className="note">
              Use sentence case capitalization without a period.
            </p>
          </div>
        </div>

        <div className="field">
          <div className="label">Applet description</div>
          <div className="input">
            <LimitedTextInput
              required
              onChange={this.handleChange.bind(this, "description")}
              value={applet.description}
              limit={500}
              counterPosition="top"
              hardLimit
              minRows={3}
              errors={errors.getAll("/description")}
            />

            <p className="note">
              Complement your title with more details about what your Applet
              will do and why someone should turn it on.
            </p>
          </div>
        </div>

        {showPrimaryService && this.renderPrimaryServiceField()}
      </section>
    )
  }
}

AppletMetadata.propTypes = {
  applet: PropTypes.object.isRequired,
  errors: PropTypes.object,
  services: PropTypes.object.isRequired,
  showPrimaryService: PropTypes.bool.isRequired,
  update: PropTypes.func.isRequired,
}

export default AppletMetadata
